// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2SwVw","itemTitle":"ClientEmergencyInfo_itemTitle__2CC7U","itemText":"ClientEmergencyInfo_itemText__2eezU"};